<div>
    <img #gmap style="height: 250px; width: 100%; margin-bottom: 10px;" />
    <div style="position: relative;">
      <div class="location-info-header">
        <h2>{{ location?.Name }} ({{location?.LocationCode}})</h2><button style="margin-top: 10px;" mat-button color="primary" *ngIf="Settings.getUser().MayImpersonate && !Settings.getUser().Impersonating" (click)="impersonate()"><mat-icon>person</mat-icon><span>{{ 'TO.ActiveContracts.cmdImpersonate' | translate:'Impersonate'}}</span></button>
      </div>
      <p>
        {{ location?.Address }}<br />
        {{ location?.ZipCode }} {{ location?.City }}<br /><br />
        {{ location?.Phone }}<br />
        <a href="mailto:{{ location?.Email }}">{{ location?.Email}}</a>
        <h2 *ngIf="serviceGuy">{{ 'T4.Service.ServiceGuy.colServiceGuy' | translate : 'ServiceGuy' }}</h2>
        <p *ngIf="serviceGuy">
          {{ serviceGuy?.Firstname}} {{ serviceGuy?.Lastname}}<br />
          {{ serviceGuy?.Companyname }}<br/>
          {{ serviceGuy?.Phone}}
        </p>      
      <p style="text-align: right; font-size: 0.8em;">{{ location?.OpenHours }}</p>
      <div *ngIf="location?.Distance" style="position:absolute; top: 0; right: 0; font-weight: bold;">{{ location?.Distance | number : '0.0-0' }}km</div>
      </div>
    </div>
